module.exports = __webpack_public_path__ + "img/personal_welcome_tree.18fe26ba.png";